@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/common" as c;
@use "styles/abstracts/mixins/typography" as t;

.portalWrap {
  position: absolute;
  top: 0;
  left: 0;
  z-index: v.$z-index-tooltip-portal-wrap;

  @include c.media(v.$container-tablet) {
    display: none;

    &.enabledOnMobile {
      display: block;
    }
  }
}

.tooltip {
  z-index: v.$z-index-ui-tooltip;
  position: relative;
}

.tooltipContent {
  position: relative;
  padding: 8px 16px;
  @include t.text(14px, 22px, 400);
  color: v.$palette-white;
  background-color: v.$palette-orange-2;
  border-radius: 8px;

  svg path {
    fill: v.$palette-orange-2;
  }

  .arrowBottom {
    position: absolute;

    &.bottom,
    &.top {
      left: 50%;
    }

    &.bottom {
      bottom: -7px;
      transform: translateX(-50%);
    }

    &.top {
      top: -7px;
      transform: translateX(-50%) rotate(180deg);
    }
  }
}
